import request from '../axios'

export const updateWeather = (data) => request({
  url: 'http://182.247.245.40:8090/bn_data/saveData',
  method: 'post',
  data: data
});


